import * as React from 'react';
import { ImageUploader } from './ImageUploader';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { Dialog } from '@shared/ui-react/Dialog';

export const ImagesUploaderDialog = {
    open: (opts: {
        initialFiles?: File[];
        treeData: ITreeData;
        onQueueComplete: () => void;
        onClickDone: () => void;
        persistState?: boolean;
        initialFolderId?: number | (() => number);
        getAlignment: () => { alignmentName: string; station: number }; // used for renaming,
        getActiveModelName: () => string;
    }) => {
        let folderId = null;
        if (typeof opts.initialFolderId === 'function') {
            folderId = opts.initialFolderId();
        }

        const targetEl = document.getElementById('react-portal-root');
        ReactUtils.safeRender(
            <>
                <Dialog onClose={ImagesUploaderDialog.close} title={kuura.getMessage('js_files.upload_btn')}>
                    <div className='padded flex-column' style={{ overflow: 'hidden' }}>
                        <ImageUploader
                            initialFiles={opts.initialFiles}
                            folderId={folderId}
                            treeData={opts.treeData}
                            onQueueComplete={opts.onQueueComplete}
                            persistState={opts.persistState}
                            onClickDone={opts.onClickDone}
                            canRenameImage={true}
                            getAlignment={() => (typeof opts.getAlignment === 'function' ? opts.getAlignment() : { alignmentName: null, station: null })}
                            getActiveModelName={() => (typeof opts.getActiveModelName === 'function' ? opts.getActiveModelName() : null)}
                            getBValue={() => null}
                        />
                    </div>
                </Dialog>
            </>,
            targetEl
        );
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    },
};
